import React, { useEffect, useMemo, useState } from "react";
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import {
  GetjobConfiguration,
  GetJobconfigurationByComapnyID,
} from "../service/jobconfigApi.js";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCartShopping,
  faCircleInfo,
  faMagnifyingGlass,
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import {
  decrement,
  increment,
  setJobId,
  setSearchItemInput,
} from "../redux/feature/jobSlice.jsx";
import { setAddedCartLength } from "../redux/feature/usersDataSIice.jsx";
import { toast } from "react-toastify";
import {
  CreateJobAPI,
  GetCartByJobId,
  SaveCartData,
} from "../service/AddCartJobs.js";
import ReactLoading from "react-loading";
import { GetCartsByUsersIdAPI } from "../service/AddCartJobs.js";
import { UpdateJobAPI } from "../service/AddCartJobs.js";
import { GetAllDataForThirdParty } from "../service/excelUpload.js";
export default function CreateJob() {
  // const location = useLocation();
  const initialValues = {
    jobscofiguration: "",
    jobscofigurationName: "",
    customername: "",
    email: "",
    phone: "",
    address: "",
    jobName: "",
    jobDescription: "",
    commission: "",
    financefee: "",
    crews: "",
    productName: "",
    productPrice: "",
    equipment: 0,
    parts: 0,
    permits: 0,
    misc: 0,
    price: "",
    quantity: "",
    totalPrice: "",
    overheadHours: "",

    laborHighViewmodelhighEmployeeCount: "",
    laborHighViewmodelhighJobHours: "",

    laborMidViewmodelemployeeNeeded: "",
    laborMidViewmodelemployeeNeededmonthlyHours: "",

    laborLowViewModelemployeeNeeded: "",
    laborLowViewModelmonthlyHours: "",

    subContractorViewmodeldaysNeeded: "",
    subContractorViewmodelratePerday: "",

    overheadViewModeldaysNeeded: "",
    overheadViewModelratePerday: "",
  };
  // const [loading, setLoading] = useState(false);
  const [jobConfigName, setJobConfigName] = useState("");
  const [jobConfigs, setJobConfigs] = useState([]);
  const [editJobId, setEditJobId] = useState("");
  const [editUserJobId, setEditUserJobId] = useState("");
  const [errors, setErrors] = useState({});
  const [formValues, setFormValues] = useState(initialValues);
  const navigate = useNavigate();
  const [value1, setValue1] = useState(0);
  const [value2, setValue2] = useState(0);
  const [tooltipVisible, setTooltipVisible] = useState(true);
  const [tooltipValue, setTooltipValue] = useState(0);
  const progress3 = (value1 / 25) * 100;
  const [tooltipVisible2, setTooltipVisible2] = useState(true);
  const [tooltipValue2, setTooltipValue2] = useState(0);
  const [equipmentTotalPrice, setEquipmentTotalPrice] = useState(0);
  const [partsTotalPrice, setPartsTotalPrice] = useState(0);
  const [permitsTotalPrice, setPermitsTotalPrice] = useState(0);
  const [miscTotalPrice, setMiscTotalPrice] = useState(0);
  const [totalPriced, setTotalPriced] = useState(0);
  // const [grandTotal, setGrandTotal] = useState(0);
  const [productData, setProductData] = useState(null);
  const jobIdData = useSelector((state) => state.jobSlice.jobId);
  const [isLoading, setIsLoading] = useState(false);

  const { id } = useParams();
  console.log(id, "jobIdFromCreateJobs");

  const isEditMode = !!id;
  const jobConDrp = localStorage.getItem("newConfigDrp");
  useEffect(() => {
    const savedFormValues = localStorage.getItem("formValues");
    console.log({ savedFormValues }, { formValues }, "Tetsing asdhasd");
    if (savedFormValues) {
      setFormValues({ ...formValues, ...JSON.parse(savedFormValues) });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    const savedCommission = localStorage.getItem("commission");
    const savedFinance = localStorage.getItem("finance");

    if (savedCommission) {
      setValue1(savedCommission);
    }

    if (savedFinance) {
      setValue2(savedFinance);
    }
  }, []);

  const handleChange = (e) => {
    e.stopPropagation();
    e.preventDefault();

    const { name, value } = e.target;
    if (
      name === "equipment" ||
      name === "parts" ||
      name === "permits" ||
      name === "misc" ||
      name === "price" ||
      // name === "totalPrice" ||
      name === "crews" ||
      name === "laborHighViewmodelhighEmployeeCount" ||
      name === "laborHighViewmodelhighJobHours" ||
      name === "laborMidViewmodelemployeeNeeded" ||
      name === "laborMidViewmodelemployeeNeededmonthlyHours" ||
      name === "laborLowViewModelemployeeNeeded" ||
      name === "laborLowViewModelmonthlyHours" ||
      name === "subContractorViewmodeldaysNeeded" ||
      name === "subContractorViewmodelratePerday" ||
      name === "overheadHours" ||
      name === "overheadViewModeldaysNeeded" ||
      name === "overheadViewModelratePerday"
    ) {
      if (value.length > 9) {
        return;
      }
    }
    const updatedValues = { ...formValues, [name]: value };
    setFormValues(updatedValues);
    localStorage.setItem("formValues", JSON.stringify(updatedValues));

    const selectedJobConfig = jobConfigs?.find(
      (job) => job.id === parseInt(value)
    );

    // setFormValues({
    //   ...formValues,
    //   [name]: value,
    // });

    if (selectedJobConfig) {
      setJobConfigName(selectedJobConfig.jobConfigName);
      localStorage.setItem(
        "newConfigDrp",
        JSON.stringify(selectedJobConfig.jobConfigName)
      );
    }

    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: false }));
    }
  };

  const userInfo = JSON.parse(localStorage.getItem("AUTH_USER"));
  const userRole = userInfo?.userRole;

  // const { companyId } = useSelector((state) => state?.jobSlice);

  // let comapany_ID1 = companyId?.adminID;

  let companyId = localStorage.getItem("admin_id");
  let companyName = localStorage.getItem("companyName");

  // useEffect(()=>{
  //   companyId = localStorage.getItem("admin_id")
  //   // companyName = localStorage.getItem("companyName")
  // },[])

  const getConfiguration = async () => {
    let response;
    if (userRole === "SuperAdmin") {
      response = await GetJobconfigurationByComapnyID(companyId);
    } else if (
      userRole === "CompanyAdmin" ||
      userRole === "CompanyUser" ||
      userRole === "CompanyManager"
    ) {
      response = await GetjobConfiguration();
    }
    setJobConfigs(response?.data);
  };

  useEffect(() => {
    getConfiguration();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { state } = useLocation();
  console.log("datadata", state);

  const validateForm = () => {
    const newErrors = {};

    // if (!formValues.productName) {
    //   newErrors.productName = "Enter Product Name";
    // }
    if (!formValues.jobscofiguration) {
      newErrors.jobscofiguration = "Select Job Configuration";
    }
    if (!formValues.jobName) {
      newErrors.jobName = "Enter your Job Name";
    }
    // if (!formValues.jobDescription) {
    //   newErrors.jobDescription = "Enter your job description";
    // }
    if (!formValues.customername) {
      newErrors.customername = "Enter your customer name";
    }

    // if (!formValues.equipment) {
    //   newErrors.equipment = "Enter your equipment";
    // }
    // if (!formValues.parts) {
    //   newErrors.parts = "Enter your parts";
    // }
    // if (!formValues.permits) {
    //   newErrors.permits = "Enter your permits";
    // }
    // if (!formValues.misc) {
    //   newErrors.misc = "Enter your miscellaneous items";
    // }
    if (!formValues.crews) {
      newErrors.crews = "Enter the number of crews";
    }

    // if (!formValues.price) {
    //   newErrors.price = "Enter the price";
    // }
    // if (!formValues.quantity) {
    //   newErrors.quantity = "Enter the quantity";
    // }
    // if (isNaN(formValues.price) || formValues.price <= 0) {
    //   newErrors.price = "Price should be a valid number greater than zero";
    // }

    if (!formValues.overheadHours) {
      newErrors.overheadHours = "Enter the overhead hours";
    }
    // if (!formValues.email) {
    //   newErrors.email = "Enter your email address";
    // }
    // if (!formValues.phone) {
    //   newErrors.phone = "Enter your phone number";
    // }
    // if (!formValues.address) {
    //   newErrors.address = "Enter your address";
    // }
    // if (!formValues.laborHighViewmodelhighEmployeeCount) {
    //   newErrors.laborHighViewmodelhighEmployeeCount =
    //     "Enter the number of high-level employees";
    // }
    // if (!formValues.laborHighViewmodelhighJobHours) {
    //   newErrors.laborHighViewmodelhighJobHours =
    //     "Enter the number of high-level job hours";
    // }
    // if (!formValues.laborMidViewmodelemployeeNeeded) {
    //   newErrors.laborMidViewmodelemployeeNeeded =
    //     "Enter the number of mid-level employees needed";
    // }
    // if (!formValues.laborMidViewmodelemployeeNeededmonthlyHours) {
    //   newErrors.laborMidViewmodelemployeeNeededmonthlyHours =
    //     "Enter the monthly hours for mid-level employees";
    // }
    // if (!formValues.laborLowViewModelemployeeNeeded) {
    //   newErrors.laborLowViewModelemployeeNeeded =
    //     "Enter the number of low-level employees needed";
    // }
    // if (!formValues.laborLowViewModelmonthlyHours) {
    //   newErrors.laborLowViewModelmonthlyHours =
    //     "Enter the monthly hours for low-level employees";
    // }
    // if (!formValues.overheadViewModeldaysNeeded) {
    //   newErrors.overheadViewModeldaysNeeded =
    //     "Enter the number of days needed for subcontractors";
    // }
    // if (!formValues.overheadViewModelratePerday) {
    //   newErrors.overheadViewModelratePerday =
    //     "Enter the subcontractor rate per day";
    // }
    // if (!formValues.subContractorViewmodeldaysNeeded) {
    //   newErrors.subContractorViewmodeldaysNeeded =
    //     "Enter the number of overhead days needed";
    // }
    // if (!formValues.subContractorViewmodelratePerday) {
    //   newErrors.subContractorViewmodelratePerday =
    //     "Enter the overhead rate per day";
    // }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const navigateToJobDetails = (createdJobId, jobDetails) => {
    console.log(jobDetails, "jobDetails");
    navigate(`/JobDetails/${createdJobId}`, {
      state: {
        createdJobId,
        jobConfigId: formValues.jobscofiguration,
        jobName: formValues.jobName,
        jobDetails,
      },
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const isValid = validateForm();
    // if (!addedCartLength > 0) {
    //   toast.error("Please choose a product");
    //   return;
    // }
    if (!isValid) {
      toast.error("Please fill in all required fields.");
      return;
    }

    setIsLoading(true);

    try {
      if (isEditMode) {
        await handleUpdateJob();
        resetForm();
      } else {
        await handleCreateJob(e);
        resetForm();
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleCreateJob = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    const userDetails = {
      jobConfigId: formValues.jobscofiguration,
      jobsConfiguration: jobConDrp !== null ? jobConDrp : jobConfigName,
      customerName: formValues.customername,
      email: formValues.email,
      phone: formValues.phone,
      address: formValues.address,
      jobName: formValues.jobName,
      jobDescription: formValues.jobDescription,
      commission: value1,
      financefee: value2,
      crews: Number(formValues.crews),
      productName: formValues.productName,
      productPrice: grandTotalP || manualEntryGrandTotal,
      equipment: equipmentTotalPrice || formValues.equipment || 0,
      parts: partsTotalPrice || formValues.parts || 0,
      permits: permitsTotalPrice || formValues.permits || 0,
      misc: miscTotalPrice || formValues.misc || 0,
      price: formValues.price || 0,
      quantity: quantityP,
      // quantity: iscount,
      // totalPrice: formValues.totalPrice,
      totalPrice: formValues.price * quantityP,
      overheadHours: formValues.overheadHours,

      userId: userRole === "CompanyUser" ? userInfo.userId : customerUsersData,
      laborHighViewmodel: {
        highEmployeeCount: formValues.laborHighViewmodelhighEmployeeCount || 0,

        highJobHours:
          Number(formValues.laborHighViewmodelhighJobHours) *
            formValues.laborHighViewmodelhighEmployeeCount || 0,
      },
      laborMidViewmodel: {
        employeeNeeded: Number(formValues.laborMidViewmodelemployeeNeeded) || 0,
        monthlyHours:
          Number(formValues.laborMidViewmodelemployeeNeededmonthlyHours) *
            Number(formValues.laborMidViewmodelemployeeNeeded) || 0,
      },
      laborLowViewModel: {
        employeeNeeded: Number(formValues.laborLowViewModelemployeeNeeded) || 0,
        monthlyHours:
          Number(formValues.laborLowViewModelmonthlyHours) *
            Number(formValues.laborLowViewModelemployeeNeeded) || 0,
      },
      subContractorViewmodel: {
        daysNeeded: Number(formValues.subContractorViewmodeldaysNeeded) || 0,
        ratePerday: Number(formValues.subContractorViewmodelratePerday) || 0,
      },
      overheadViewModel: {
        daysNeeded: Number(formValues.overheadViewModeldaysNeeded) || 0,
        ratePerday: Number(formValues.overheadViewModelratePerday) || 0,
      },
    };
    try {
      const response = await CreateJobAPI(userDetails);
      if (response.statusCode === 200) {
        const createdJobId = response?.data;

        await SaveProductdata(createdJobId);
        navigateToJobDetails(createdJobId, userDetails);

        dispatch(setAddedCartLength(0));
        toast.success(response?.message);
        localStorage.removeItem("newConfigDrp");
      } else {
        toast.error(
          response.response.data.errors.JobsConfiguration[0] ||
            "Something went wrong!"
        );
        console.log(
          response.response.data.errors.JobsConfiguration[0],
          "responseData"
        );
      }
    } catch (error) {
      console.log("Error while submit the results", error);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const SaveProductdata = async (jobId) => {
    const productDetails = {
      cartItems: productData?.map((ele) => {
        return {
          jobId: jobId,
          productName: ele.productName,
          productPrice: ele.productPrice,
          typeOfSupply: ele.typeofSupply || ele.typeOfSupply,
          quantity: ele.quantity,
          userId: ele.userId,
        };
      }),
    };

    try {
      const response = await SaveCartData(productDetails, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response?.statusCode) {
        console.log(response?.message);
      }
    } catch (error) {
      console.log("Error while submitting the results", error);
    }
  };

  var DataID = localStorage.getItem("companyUserId");

  const resetForm = () => {
    setFormValues(initialValues);
    dispatch(setAddedCartLength(0));
    setEquipmentTotalPrice(0);
    setPartsTotalPrice(0);
    setPermitsTotalPrice(0);
    setMiscTotalPrice(0);
    localStorage.removeItem("formValues");
    localStorage.removeItem("SearchQuery");
    localStorage.removeItem("commission");
    localStorage.removeItem("finance");
  };

  const CustomClose = () => {
    SaveProductdata();
    resetForm();
    if (userRole === "CompanyUser") {
      navigate("/AllJobs");
    } else {
      navigate(`/AllJobs/${DataID}`);
    }
  };

  const handleChange1 = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const newValue = e.target.value;
    setValue1(newValue);
    localStorage.setItem("commission", newValue);
    setTooltipValue(tooltipValue);
  };

  const handleChange2 = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const newValue2 = e.target.value;
    localStorage.setItem("finance", newValue2);
    setValue2(newValue2);
    setTooltipValue2(tooltipValue2);
  };

  const progress2 = (value2 / 25) * 100;

  const [cartData, setCartData] = useState("");
  const dispatch = useDispatch();
  const searchItemInput = useSelector(
    (state) => state.jobSlice.searchItemInput
  );
  const [data, setdata] = useState([]);

  useEffect(() => {
    getExcelFileListData9();
  }, []);
  const companyNameData =
    userRole === "SuperAdmin" ? companyName : userInfo?.companyName;

  const getExcelFileListData9 = async () => {
    try {
      const result = await GetAllDataForThirdParty();

      setdata(result?.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const thirdpartyAccessData = data?.find(
    (item) => item.companyName === companyNameData
  )?.thirdPartyAccess;
  localStorage.setItem("thirdpartyAccessData", thirdpartyAccessData);

  const handleSearch = (e) => {
    e.stopPropagation();
    if (searchItemInput.trim() !== "") {
      dispatch(setSearchItemInput(searchItemInput));
      localStorage.setItem("SearchQuery", searchItemInput);
      navigate(`/search?query=${searchItemInput}`);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch(e);
    }
  };

  const addedCartLength = useSelector((state) => state.auth?.addedCartLength);

  const customerUsersData = useSelector(
    (state) => state.auth?.customerUsersData
  );

  const quantityP = useSelector((state) => state.jobSlice?.value);

  const handleGetCardByUserId = async () => {
    try {
      const response = await GetCartsByUsersIdAPI(
        userRole === "CompanyUser" ? userInfo.userId : customerUsersData
      );

      setEquipmentTotalPrice(response?.data?.equipmentTotalPrice);
      setPartsTotalPrice(response?.data?.partsTotalPrice);
      setPermitsTotalPrice(response?.data?.permitsTotalPrice);
      setMiscTotalPrice(response?.data?.miscTotalPrice);
      setTotalPriced(response?.data?.totalPrice);
      setProductData(response?.data?.cartData);

      dispatch(setAddedCartLength(response?.data?.cartData?.length));
      if (response?.data?.cartData && response?.data?.cartData.length > 0) {
        const product = response?.data?.cartData[0];
        setCartData(product?.typeofSupply);

        // let price = product?.productPrice || 0
      }
    } catch (error) {
      console.error("Error fetching cart data", error);
    }
  };

  const handleGetCardByJobId = async () => {
    try {
      const response = await GetCartByJobId(jobIdData.id);

      setEquipmentTotalPrice(response?.data?.equipmentTotalPrice);
      setPartsTotalPrice(response?.data?.partsTotalPrice);
      setPermitsTotalPrice(response?.data?.permitsTotalPrice);
      setMiscTotalPrice(response?.data?.miscTotalPrice);
      setTotalPriced(response?.data?.totalPrice);

      setProductData(response.data.cartData);
      dispatch(setAddedCartLength(response?.data?.cartData?.length));
      if (response?.data?.cartData && response?.data?.cartData.length > 0) {
        const product = response?.data?.cartData[0];

        setCartData(product?.typeofSupply);

        // let price = product?.productPrice || 0
      }
    } catch (error) {
      console.error("Error fetching cart data", error);
    }
  };

  useEffect(() => {
    if (jobIdData.id) {
      handleGetCardByJobId();
    } else {
      handleGetCardByUserId();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userRole === "CompanyUser" ? userInfo.userId : customerUsersData]);

  const { jobId } = useSelector((state) => state.jobSlice);
  // const grandTotalPrice =
  //   parseFloat(formValues.price) * parseFloat(quantityP) +
  //   totalPriced +
  //   (parseFloat(formValues.equipment) || 0) +
  //   (parseFloat(formValues.parts) || 0) +
  //   (parseFloat(formValues.misc) || 0) +
  //   (parseFloat(formValues.permits) || 0);

  const grandTotalP = useMemo(() => {
    return (
      formValues.price * quantityP +
      totalPriced +
      (equipmentTotalPrice > 0 ? 0 : parseFloat(formValues.equipment) || 0) +
      (partsTotalPrice > 0 ? 0 : parseFloat(formValues.parts) || 0) +
      (miscTotalPrice > 0 ? 0 : parseFloat(formValues.misc) || 0) +
      (permitsTotalPrice > 0 ? 0 : parseFloat(formValues.permits) || 0)
    );
  }, [
    formValues.price,
    formValues.equipment,
    formValues.parts,
    formValues.misc,
    formValues.permits,
    quantityP,
    totalPriced,
    equipmentTotalPrice,
    partsTotalPrice,
    miscTotalPrice,
    permitsTotalPrice,
  ]);
  const manualEntryGrandTotal =
    Number(formValues.equipment) +
    Number(formValues.parts) +
    Number(formValues.permits) +
    Number(formValues.misc) +
    Number(formValues.price) * Number(quantityP);

  console.log(manualEntryGrandTotal, "manualEntryGrandTotal");
  useEffect(() => {
    if (isEditMode && jobId) {
      console.log(jobId, "DataSet");
      console.log(
        "high hrs",
        jobId.laborHigh?.jobHours / jobId.laborHigh?.employNeeded
      );
      setFormValues({
        jobscofiguration: jobId.jobConfigId || "",
        jobscofigurationName: jobId.jobsConfiguration || "",
        customername: jobId.customerName || "",
        email: jobId.email || "",
        phone: jobId.phone || "",
        address: jobId.address || "",
        jobName: jobId.jobName || "",
        jobDescription: jobId.jobDescription || "",
        commission: jobId.commission || "",
        financefee: jobId.financefee || "",
        crews: jobId.crewRunning || "",
        productName: jobId.productName || "",
        productPrice: jobId.productPrice || "",
        equipment: jobId.equipment?.totalSuplly || "",
        parts: jobId.parts?.totalSuplly || "",
        permits: jobId.permits?.totalSuplly || "",
        misc: jobId.misc?.totalSuplly || "",
        price: jobId.price || "",
        quantity: jobId.quantity || "",
        totalPrice: jobId.totalPrice || "",
        overheadHours: jobId.overheadHaurs?.jobHours || "",

        laborHighViewmodelhighEmployeeCount: jobId.laborHigh?.employNeeded || 0,
        laborHighViewmodelhighJobHours:
          jobId.laborHigh?.jobHours / jobId.laborHigh?.employNeeded || 0,

        laborMidViewmodelemployeeNeeded: jobId.laborMid?.employNeeded || 0,
        laborMidViewmodelemployeeNeededmonthlyHours:
          jobId.laborMid?.jobHours / jobId.laborMid?.employNeeded || 0,

        laborLowViewModelemployeeNeeded: jobId.laborLow?.employNeeded || 0,
        laborLowViewModelmonthlyHours:
          jobId.laborLow?.jobHours / jobId.laborLow?.employNeeded || 0,

        subContractorViewmodeldaysNeeded: jobId.subContractor?.daysNeeded || 0,
        subContractorViewmodelratePerday: jobId.subContractor?.ratePerday || 0,

        overheadViewModeldaysNeeded: jobId.overhead?.daysNeeded || 0,
        overheadViewModelratePerday: jobId.overhead?.ratePerday || 0,
      });
      setEditJobId(jobId?.id);
      setEditUserJobId(jobId?.userId);
      setValue1(jobId?.commission);
      setValue2(jobId?.financefee);
    }
  }, [isEditMode, jobId]);

  const handleUpdateJob = async (data) => {
    const userDetails = {
      jobConfigId: formValues.jobscofiguration,
      jobsConfiguration:
        jobConDrp !== null ? jobConDrp : formValues.jobscofigurationName,
      customerName: formValues.customername,
      email: formValues.email,
      phone: formValues.phone,
      address: formValues.address,
      jobName: formValues.jobName,
      jobDescription: formValues.jobDescription,
      commission: value1,
      financefee: value2,
      crews: formValues.crews,
      productName: formValues.productName,
      // productName: itemDtails.productName || "string",
      productPrice: grandTotalP ?? manualEntryGrandTotal,
      equipment: equipmentTotalPrice || formValues.equipment || 0,
      parts: partsTotalPrice || formValues.parts || 0,
      permits: permitsTotalPrice || formValues.permits || 0,
      misc: miscTotalPrice || formValues.misc || 0,
      // equipment: formValues.equipment,
      // parts: formValues.parts,
      // permits: formValues.permits,
      // misc: formValues.misc,
      price: formValues.price || 0,
      quantity: quantityP,
      totalPrice: formValues.price * quantityP,
      overheadHours: formValues.overheadHours,
      userId: editUserJobId,
      laborHighViewmodel: {
        highEmployeeCount:
          Number(formValues.laborHighViewmodelhighEmployeeCount) || 0,
        highJobHours:
          Number(formValues.laborHighViewmodelhighJobHours) *
            Number(formValues.laborHighViewmodelhighEmployeeCount) || 0,
      },
      laborMidViewmodel: {
        employeeNeeded: Number(formValues.laborMidViewmodelemployeeNeeded) || 0,
        monthlyHours:
          Number(formValues.laborMidViewmodelemployeeNeededmonthlyHours) *
            Number(formValues.laborMidViewmodelemployeeNeeded) || 0,
      },
      laborLowViewModel: {
        employeeNeeded: Number(formValues.laborLowViewModelemployeeNeeded) || 0,
        monthlyHours:
          Number(formValues.laborLowViewModelmonthlyHours) *
            Number(formValues.laborLowViewModelemployeeNeeded) || 0,
      },
      subContractorViewmodel: {
        daysNeeded: Number(formValues.subContractorViewmodeldaysNeeded) || 0,
        ratePerday: Number(formValues.subContractorViewmodelratePerday),
      },
      overheadViewModel: {
        daysNeeded: Number(formValues.overheadViewModeldaysNeeded) || 0,
        ratePerday: Number(formValues.overheadViewModelratePerday) || 0,
      },
      id: editJobId,
    };
    // setEquipmentTotalPrice(response?.data?.equipmentTotalPrice);
    //   setPartsTotalPrice(response?.data?.partsTotalPrice);
    //   setPermitsTotalPrice(response?.data?.permitsTotalPrice);
    //   setMiscTotalPrice(response?.data?.miscTotalPrice);
    try {
      const response = await UpdateJobAPI(userDetails);

      if (response.statusCode === 200) {
        dispatch(setJobId(jobIdData.id));
        // dispatch(setEditUserDeatils(false));
        toast.success("Job updated successfully!");
        navigateToJobDetails(id, userDetails);
        dispatch(setAddedCartLength(0));
      } else {
        toast.error("Failed to update job");
      }
    } catch (error) {
      console.error("Error while updating job", error);
      toast.error("Failed to update job.");
    }
  };

  const handleNavigateToCart = () => {
    navigate("/cartListData");
  };

  return (
    <Container fluid className="p-0 my-3 createJobSection">
      {isLoading ? (
        <ReactLoading
          type={"bars"}
          color="#33995e"
          height={60}
          width={60}
          className={"globe_loader"}
        />
      ) : (
        <form onSubmit={(e) => handleSubmit(e)}>
          <Row className="mb-3">
            <Col md={12}>
              <Button variant="secondary" onClick={CustomClose}>
                Back
              </Button>
              <h5 className="mb-3 mt-4 flex-1">Supply Cost</h5>

              <Card className="border-0 p-3 rounded">
                <div className="row custom_fields remove_class">
                  <div className="col-sm-12">
                    <div className="row mb-3">
                      <div className="col-sm-3 pe-0">
                        {" "}
                        <div className="position-relative search_field_container  ">
                          <input
                            type="text"
                            className="form-control me-2 mb-0 custom_search"
                            value={searchItemInput}
                            onKeyPress={handleKeyPress}
                            onChange={(e) =>
                              dispatch(setSearchItemInput(e.target.value))
                            }
                            placeholder="Search for products..."
                          />

                          <button className="position-absolute btn " hidden>
                            <FontAwesomeIcon icon={faMagnifyingGlass} />
                          </button>
                        </div>
                      </div>

                      <div className="col-sm-auto  d-flex align-items-center">
                        <Button
                          className="me-2 btn-success"
                          onClick={handleSearch}
                        >
                          Search
                        </Button>
                        <div className="info_icon">
                          <div className="tooltip">
                            <FontAwesomeIcon icon={faCircleInfo} />
                            <span className="tooltiptext ">
                              Search for all equipment and parts in our data
                              base.
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-auto  ms-auto">
                        <div className="add_Cart_sec position-relative">
                          <div className="notification-count">
                            {addedCartLength || 0}
                          </div>
                          <button
                            className="border-0 add_to_cart rounded "
                            // onClick={handleShow}
                            onClick={handleNavigateToCart}
                            // onClick={() => navigate("/cartListData")}
                          >
                            <FontAwesomeIcon icon={faCartShopping} />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Row>
                  <Col md={12} hidden>
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Product Title</Form.Label>
                      <Form.Control
                        type="text"
                        name="productName"
                        value={cartData?.productName || formValues?.productName}
                        onChange={handleChange}
                        className={`px-3 ${
                          errors.productName ? "border-danger mb-0" : ""
                        }`}
                        placeholder="Product Title"
                      />
                      {errors.productName && (
                        <Form.Text className="text-danger">
                          Product Name
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Equipment</Form.Label>
                      <div className="input-group common_doller_class">
                        <span className="input-group-text">$</span>
                        <Form.Control
                          type="number"
                          name="equipment"
                          value={
                            equipmentTotalPrice
                              ? equipmentTotalPrice
                              : formValues.equipment
                          }
                          onChange={handleChange}
                          className={`px-3 ${
                            errors.equipment ? "border-danger mb-0" : ""
                          }`}
                          placeholder="Equipment"
                          disabled={equipmentTotalPrice > 0}
                        />
                      </div>
                      {errors.equipment && (
                        <Form.Text className="text-danger">
                          Enter your equipment
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Parts</Form.Label>
                      <div className="input-group common_doller_class">
                        <span className="input-group-text">$</span>
                        <Form.Control
                          type="number"
                          name="parts"
                          value={
                            partsTotalPrice ? partsTotalPrice : formValues.parts
                          }
                          onChange={handleChange}
                          className={`px-3 ${
                            errors.parts ? "border-danger mb-0" : ""
                          }`}
                          placeholder="Parts"
                          maxLength={10}
                          disabled={partsTotalPrice > 0}
                        />
                      </div>
                      {errors.parts && (
                        <Form.Text className="text-danger">
                          Enter your parts
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Permits</Form.Label>
                      <div className="input-group common_doller_class">
                        <span className="input-group-text">$</span>
                        <Form.Control
                          type="number"
                          name="permits"
                          value={
                            permitsTotalPrice
                              ? permitsTotalPrice
                              : formValues.permits
                          }
                          onChange={handleChange}
                          className={`px-3 ${
                            errors.permits ? "border-danger mb-0" : ""
                          }`}
                          placeholder="Permits"
                          maxLength={10}
                          disabled={permitsTotalPrice > 0}
                        />
                      </div>
                      {errors.permits && (
                        <Form.Text className="text-danger">
                          Enter your permits
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Misc</Form.Label>
                      <div className="input-group common_doller_class">
                        <span className="input-group-text">$</span>
                        <Form.Control
                          type="number"
                          name="misc"
                          value={
                            miscTotalPrice ? miscTotalPrice : formValues.misc
                          }
                          onChange={handleChange}
                          className={`px-3 ${
                            errors.misc ? "border-danger mb-0" : ""
                          }`}
                          placeholder="Misc"
                          maxLength={10}
                          disabled={miscTotalPrice > 0}
                        />
                      </div>
                      {errors.misc && (
                        <Form.Text className="text-danger">
                          Enter your misc
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={1}>
                    <Form.Label>Quantity</Form.Label>
                    <div className="quantity">
                      <button
                        type="button"
                        onClick={() => dispatch(decrement())}
                      >
                        -
                      </button>
                      <span className="mx-2">{quantityP || "1"}</span>
                      <button
                        type="button"
                        onClick={() => dispatch(increment())}
                      >
                        +
                      </button>
                    </div>
                  </Col>

                  <Col md={3}>
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Price</Form.Label>
                      <div className="input-group common_doller_class">
                        <span className="input-group-text">$</span>
                        <Form.Control
                          type="number"
                          name="price"
                          value={formValues.price}
                          onChange={handleChange}
                          className={`px-3 ${
                            errors.price ? "border-danger mb-0" : ""
                          }`}
                          placeholder="Price"
                          maxLength={10}
                        />
                      </div>
                      {errors.price && (
                        <Form.Text className="text-danger">
                          Enter your Price
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Total Price</Form.Label>
                      <div className="input-group common_doller_class">
                        <span className="input-group-text">$</span>
                        <Form.Control
                          type="number"
                          name="totalPrice"
                          // value={formValues.totalPrice}
                          value={formValues.price * quantityP || 0}
                          onChange={handleChange}
                          disabled
                          className={`px-3 ${
                            errors.totalPrice ? "border-danger mb-0" : ""
                          }`}
                          readOnly
                          placeholder="Total Price"
                        />
                      </div>
                      {errors.totalPrice && (
                        <Form.Text className="text-danger">
                          Enter your Total Price
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Grand Total</Form.Label>
                      <div className="input-group common_doller_class">
                        <span className="input-group-text">$</span>
                        <Form.Control
                          type="number"
                          name="productPrice"
                          // value={grandTotalP || 0}
                          value={
                            grandTotalP ? grandTotalP : manualEntryGrandTotal
                          }
                          // value={
                          //   totalPriced +
                          //     Number(formValues.price * quantityP) || ""
                          // }
                          // value={grandTotal.toFixed(2)}
                          readOnly
                          disabled
                          //  value={grandTotal + Number(formValues.price * value)}
                          onChange={handleChange}
                          className={`px-3 ${
                            errors.productPrice ? "border-danger mb-0" : ""
                          }`}
                          placeholder="Grand Total"
                        />
                      </div>
                      {errors.productPrice && (
                        <Form.Text className="text-danger">
                          Grand Total
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={12}>
              <h5 className="mb-3">General info</h5>
              <Card className="border-0 p-3 rounded">
                <Row>
                  <Col md={3}>
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlInput1"
                    >
                      <label className="d-flex gap-2 mb-0">
                        Jobs Configuration{" "}
                        <span className="fs-5 text-danger">*</span>
                      </label>

                      <select
                        name="jobscofiguration"
                        value={formValues.jobscofiguration}
                        onChange={handleChange}
                        className={`px-3 d-block custom-select ${
                          errors.jobscofiguration ? "border-danger mb-0 " : ""
                        }`}
                      >
                        {" "}
                        {<option value=" ">Select Job Configuration</option>}
                        {jobConfigs?.map((job, index) => (
                          <option
                            value={job.id}
                            key={job.id}
                            // selected={index === 0}
                          >
                            {job.jobConfigName}
                          </option>
                        ))}
                      </select>
                      {errors.jobscofiguration && (
                        <Form.Text className="text-danger">
                          Enter your jobscofiguration
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label className="d-flex gap-2 mb-0">
                        Customer Name{" "}
                        <span className="fs-5 text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="customername"
                        value={formValues.customername}
                        onChange={handleChange}
                        className={`px-3 ${
                          errors.customername ? "border-danger mb-0" : ""
                        }`}
                        placeholder="Enter Customer Name"
                      />
                      {errors.customername && (
                        <Form.Text className="text-danger">
                          Enter your customer Name
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={formValues.email}
                        onChange={handleChange}
                        className={`px-3 ${
                          errors.email ? "border-danger mb-0" : ""
                        }`}
                        placeholder="Email"
                      />
                      {errors.email && (
                        <Form.Text className="text-danger">
                          Enter your email
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Phone</Form.Label>
                      <Form.Control
                        type="number"
                        name="phone"
                        value={formValues.phone}
                        onChange={handleChange}
                        className={`px-3 ${
                          errors.phone ? "border-danger mb-0" : ""
                        }`}
                        placeholder="Phone"
                      />
                      {errors.email && (
                        <Form.Text className="text-danger">
                          Enter your phone
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Address</Form.Label>
                      <Form.Control
                        type="text"
                        name="address"
                        value={formValues.address}
                        onChange={handleChange}
                        className={`px-3 ${
                          errors.address ? "border-danger mb-0" : ""
                        }`}
                        placeholder="Address"
                      />
                      {errors.address && (
                        <Form.Text className="text-danger">
                          Enter your address
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={3}>
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label className="d-flex gap-2 mb-0">
                        Job Name<span className="fs-5 text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="jobName"
                        value={formValues.jobName}
                        onChange={handleChange}
                        className={`px-3 ${
                          errors.jobName ? "border-danger mb-0" : ""
                        }`}
                        placeholder="Enter Job Name"
                      />
                      {errors.jobName && (
                        <Form.Text className="text-danger">
                          Enter Job Name
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Description</Form.Label>
                      <Form.Control
                        type="text"
                        name="jobDescription"
                        value={formValues.jobDescription}
                        onChange={handleChange}
                        className={`px-3 ${
                          errors.jobDescription ? "border-danger mb-0" : ""
                        }`}
                        placeholder="Description"
                      />
                      {errors.description && (
                        <Form.Text className="text-danger">
                          Enter your description
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <div className="d-flex">
                <h5 className="mb-3  ">Crews </h5>
                <div className="info_icon">
                  <div className="tooltip">
                    <FontAwesomeIcon icon={faCircleInfo} />
                    <span className="tooltiptext ">
                      Enter in how many billable jobs you run a day on average
                      this is very important to split your overhead up
                      correctly!
                    </span>
                  </div>
                </div>
              </div>
              <Card className="border-0 p-3 rounded">
                <Row>
                  <Col md={12}>
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label className="d-flex gap-2 mb-0">
                        Crews <span class="fs-5 text-danger">*</span>
                      </Form.Label>

                      <Form.Control
                        type="number"
                        name="crews"
                        value={formValues.crews}
                        onChange={handleChange}
                        className={`px-3 ${
                          errors.crews ? "border-danger mb-0" : ""
                        }`}
                        placeholder="No. of Crews "
                      />
                      {errors.crews && (
                        <Form.Text className="text-danger">
                          Enter your number crew running
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
              </Card>
            </Col>
            <Col md={4}>
              <h5 className="mb-3">Commission</h5>
              <Card className="border-0 p-3 rounded">
                <Form.Group className="" controlId="exampleForm.ControlInput1">
                  <Form.Label>Commission Fee</Form.Label>
                  <div className="range-input-container mt-4">
                    <div className="slider-container">
                      <input
                        type="range"
                        id="range"
                        min="0"
                        max="25"
                        value={value1}
                        onChange={handleChange1}
                        onMouseEnter={() => setTooltipVisible(true)}
                        onMouseLeave={() => setTooltipVisible(true)}
                        style={{
                          background: `linear-gradient(to right, #25D366 ${progress3}%, #ccc ${progress3}%)`,
                        }}
                      />
                      {tooltipVisible && (
                        <div>
                          <div
                            className="tooltip"
                            style={{
                              left: `${progress3}%`,
                              transform: "translateX(-50%)",
                            }}
                          >
                            {value1}
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="range-labels d-flex justify-content-between">
                      <span>0</span>
                      <span>25</span>
                    </div>
                  </div>
                </Form.Group>
              </Card>
            </Col>{" "}
            <Col md={4}>
              <h5 className="mb-3">Finance</h5>
              <Card className="border-0 p-3 rounded">
                <Form.Group className="" controlId="exampleForm.ControlInput1">
                  <Form.Label>Finance Fee</Form.Label>
                  <div className="range-input-container mt-4">
                    <div className="slider-container">
                      <input
                        type="range"
                        id="range"
                        min="0"
                        max="25"
                        value={value2}
                        onChange={handleChange2}
                        onMouseEnter={() => setTooltipVisible2(true)}
                        onMouseLeave={() => setTooltipVisible2(true)}
                        style={{
                          background: `linear-gradient(to right, #25D366 ${progress2}%, #ccc ${progress2}%)`,
                        }}
                      />
                      {/* <div className="value text-center">{value2}%</div> */}
                      {tooltipVisible2 && (
                        <div>
                          <div
                            className="tooltip-item"
                            style={{
                              left: `${progress2}%`,
                              transform: "translateX(-50%)",
                            }}
                          >
                            {value2}
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="range-labels d-flex justify-content-between">
                      <span>0</span>
                      <span>25</span>
                    </div>
                  </div>
                </Form.Group>
              </Card>
            </Col>
          </Row>

          {/* Employee Cost and Sub Contractor Cost */}
          <Row className="mb-3 mt-3">
            <Col md={6}>
              <h5 className="mb-3">Employee Cost</h5>
              <Card className="border-0 p-3 rounded">
                <Row>
                  <Col md={6}>
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Labor High(Number of crew) </Form.Label>
                      <Form.Control
                        type="number"
                        name="laborHighViewmodelhighEmployeeCount"
                        value={formValues.laborHighViewmodelhighEmployeeCount}
                        onChange={handleChange}
                        className={`px-3 ${
                          errors.laborHighViewmodelhighEmployeeCount
                            ? "border-danger mb-0"
                            : ""
                        }`}
                        placeholder="Employees needed"
                      />
                      {errors.laborHighViewmodelhighEmployeeCount && (
                        <Form.Text className="text-danger">
                          Enter your labor high
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group
                      className="mb-3 mt-2"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Number of hours </Form.Label>
                      <Form.Control
                        type="number"
                        name="laborHighViewmodelhighJobHours"
                        value={formValues.laborHighViewmodelhighJobHours}
                        onChange={handleChange}
                        className={`px-3 ${
                          errors.laborHighViewmodelhighJobHours
                            ? "border-danger mb-0"
                            : ""
                        }`}
                        placeholder="Job Hours"
                      />
                      {errors.laborHighViewmodelhighJobHours && (
                        <Form.Text className="text-danger">
                          Enter your job hours
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Labor Mid(Number of crew) </Form.Label>
                      <Form.Control
                        type="number"
                        name="laborMidViewmodelemployeeNeeded"
                        value={formValues.laborMidViewmodelemployeeNeeded}
                        onChange={handleChange}
                        className={`px-3 ${
                          errors.laborMidViewmodelemployeeNeeded
                            ? "border-danger mb-0"
                            : ""
                        }`}
                        placeholder="Employees needed"
                      />
                      {errors.laborMidViewmodelemployeeNeeded && (
                        <Form.Text className="text-danger">
                          Enter your labor mid
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group
                      className="mb-3 mt-2"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Number of hours</Form.Label>
                      <Form.Control
                        type="number"
                        name="laborMidViewmodelemployeeNeededmonthlyHours"
                        value={
                          formValues.laborMidViewmodelemployeeNeededmonthlyHours
                        }
                        onChange={handleChange}
                        className={`px-3 ${
                          errors.laborMidViewmodelemployeeNeededmonthlyHours
                            ? "border-danger mb-0"
                            : ""
                        }`}
                        placeholder="Job Hours"
                      />
                      {errors.laborMidViewmodelemployeeNeededmonthlyHours && (
                        <Form.Text className="text-danger">
                          Enter your number people
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Labor Low(Number of crew)</Form.Label>
                      <Form.Control
                        type="number"
                        name="laborLowViewModelemployeeNeeded"
                        value={formValues.laborLowViewModelemployeeNeeded}
                        onChange={handleChange}
                        className={`px-3 ${
                          errors.laborLowViewModelemployeeNeeded
                            ? "border-danger mb-0"
                            : ""
                        }`}
                        placeholder="Employees needed"
                      />
                      {errors.laborLowViewModelemployeeNeeded && (
                        <Form.Text className="text-danger">
                          Enter your number laborlow
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group
                      className="mb-3 mt-2"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label>Number of hours</Form.Label>
                      <Form.Control
                        type="number"
                        name="laborLowViewModelmonthlyHours"
                        value={formValues.laborLowViewModelmonthlyHours}
                        onChange={handleChange}
                        className={`px-3 ${
                          errors.laborLowViewModelmonthlyHours
                            ? "border-danger mb-0"
                            : ""
                        }`}
                        placeholder="Job Hours"
                      />
                      {errors.laborLowViewModelmonthlyHours && (
                        <Form.Text className="text-danger">
                          Enter your number number peoples
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group
                      className="mb-3"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Label className="d-flex gap-2 mb-0">
                        Overhead/Hours<span class="fs-5 text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="number"
                        name="overheadHours"
                        value={formValues.overheadHours}
                        onChange={handleChange}
                        className={`px-3 ${
                          errors.overheadHours ? "border-danger mb-0" : ""
                        }`}
                        placeholder="Overhead/Hours"
                      />
                      {errors.overheadHours && (
                        <Form.Text className="text-danger">
                          Enter your number overhead hours
                        </Form.Text>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
              </Card>
            </Col>
            <Col md={6}>
              <Row>
                <Col md={12}>
                  <h5 className="mb-3 text-white">.</h5>
                  <Card className="border-0 p-3 rounded">
                    <Row>
                      <Col md={6} hidden>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Overhead/Sub Contractor</Form.Label>
                          <Form.Control
                            type="number"
                            name="overheadViewModeldaysNeeded"
                            value={formValues.overheadViewModeldaysNeeded}
                            onChange={handleChange}
                            className={`px-3 ${
                              errors.overheadViewModeldaysNeeded
                                ? "border-danger mb-0"
                                : ""
                            }`}
                            placeholder="Days needed"
                          />
                          {errors.overheadViewModeldaysNeeded && (
                            <Form.Text className="text-danger">
                              Enter your number overhead sub
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={6} hidden>
                        <Form.Group
                          className="mb-3 mt-2"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label></Form.Label>
                          <div className="input-group common_doller_class">
                            <span className="input-group-text">$</span>

                            <Form.Control
                              type="text"
                              name="overheadViewModelratePerday"
                              value={formValues.overheadViewModelratePerday}
                              onChange={handleChange}
                              className={`px-3 ${
                                errors.overheadViewModelratePerday
                                  ? "border-danger mb-0"
                                  : ""
                              }`}
                              placeholder="Rate/day"
                            />
                          </div>
                          {errors.overheadViewModelratePerday && (
                            <Form.Text className="text-danger">
                              Enter your number rate days
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Sub Contractor Cost</Form.Label>
                          <Form.Control
                            type="number"
                            name="subContractorViewmodeldaysNeeded"
                            value={formValues.subContractorViewmodeldaysNeeded}
                            onChange={handleChange}
                            className={`px-3 ${
                              errors.subContractorViewmodeldaysNeeded
                                ? "border-danger mb-0"
                                : ""
                            }`}
                            placeholder="Days needed"
                          />
                          {errors.subContractorViewmodeldaysNeeded && (
                            <Form.Text className="text-danger">
                              Enter your number sub cost
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group
                          className="mb-3 mt-2"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label></Form.Label>
                          <div className="input-group common_doller_class">
                            <span className="input-group-text">$</span>
                            <Form.Control
                              type="text"
                              name="subContractorViewmodelratePerday"
                              value={
                                formValues.subContractorViewmodelratePerday
                              }
                              onChange={handleChange}
                              className={`px-3 ${
                                errors.subContractorViewmodelratePerday
                                  ? "border-danger mb-0"
                                  : ""
                              }`}
                              placeholder="Rate/day"
                            />
                          </div>
                          {errors.subContractorViewmodelratePerday && (
                            <Form.Text className="text-danger">
                              Enter your number rate day
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
            </Col>{" "}
          </Row>
          {/* Supply Cost */}

          <div className="d-flex justify-content-end">
            {" "}
            <Button type="submit" variant="success" className="me-2">
              {isEditMode ? "Update Job" : "Submit Job"}
            </Button>
            <Button variant="danger" onClick={CustomClose}>
              Cancel
            </Button>
          </div>
        </form>
      )}
    </Container>
  );
}
